import AScene from "../../library/ExtendedObjects/AScene";
import gameData from "../../gameData.js";
import ABCyaPhaser, { Audio } from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Intro extends AScene
{
    static get KEY() { return 'Intro'; }
    create()
    {
        var flame = [];
        var letters = [];
        var Balloon = [];
        this.heightBalloon = [];
        var heightFire = [];
        var counter;
        var string = [];
        this.string = [];
        this.count = 0;
        var sound;

        this.sound.stopAll();

        this.addImage(this.mid.x, this.mid.y, "G_bg", this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
        let bg = this.addImage(this.mid.x, this.mid.y, "Background.png");
        this.addImage(this.mid.x, this.mid.y + this.mid.y - 105, "Table.png");

        this.cont = this.addContainer(this.x, this.y);
        this.Cake = this.addContainer(this.x, this.y);
        this.Balloons = this.addContainer(this.x, this.y);

        //console.log("Upload Date: 7/28");

        var Shadow = this.addImage(606,686, "Shadow.png",this.Cake);
        Balloon[0] = this.addImage(978, this.y , "NewAsset/Orange_Balloon_1.png",this.Balloons);
        Balloon[0].setFlipX(true);
        Balloon[1] = this.addImage(845, this.y , "NewAsset/Orange_Balloon_3.png",this.Balloons);
        Balloon[1].setFlipX(true);
        Balloon[2] = this.addImage(783, this.y , "NewAsset/Orange_Balloon_4.png",this.Balloons);
        Balloon[2].setFlipX(true);
        //Balloon[2].setAngle(-8);
        Balloon[3] = this.addImage(911, this.y , "NewAsset/Orange_Balloon_2.png",this.Balloons);
        Balloon[3].setFlipX(true);
        Balloon[4] = this.addImage(96, 900 , "NewAsset/Orange_Balloon_1.png",this.Balloons);
        Balloon[5] = this.addImage(215, 900 , "NewAsset/Orange_Balloon_3.png",this.Balloons);
        Balloon[6] = this.addImage(160, 900 , "NewAsset/Orange_Balloon_4.png",this.Balloons);
        Balloon[7] = this.addImage(41, 900 , "NewAsset/Orange_Balloon_2.png",this.Balloons);
//                          0    1    2  3   4   5   6     7
        this.heightBalloon=[416,394,434,420,405,420,402,428];
        
        //Presentation left to right = 7 4 6 5  and 2 1 3 0
        /*
        this.string[0] = string[0] = this.add.rope(Balloon[0].x+9, this.heightBalloon[0]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[1] = string[1] = this.add.rope(Balloon[1].x, this.heightBalloon[1]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[2] = string[2] = this.add.rope(Balloon[2].x-2, this.heightBalloon[2]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[3] = string[3] = this.add.rope(Balloon[3].x+6, this.heightBalloon[3]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[4] = string[4] = this.add.rope(Balloon[4].x-3, this.heightBalloon[4]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[5] = string[5] = this.add.rope(Balloon[5].x+4, this.heightBalloon[5]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[6] = string[6] = this.add.rope(Balloon[6].x-5, this.heightBalloon[6]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.string[7] = string[7] = this.add.rope(Balloon[7].x-20, this.heightBalloon[7]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        */

       this.string[0] = string[0] = this.add.rope(Balloon[0].x, this.heightBalloon[0]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[1] = string[1] = this.add.rope(Balloon[1].x, this.heightBalloon[1]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[2] = string[2] = this.add.rope(Balloon[2].x+5, this.heightBalloon[2]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[3] = string[3] = this.add.rope(Balloon[3].x, this.heightBalloon[3]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[4] = string[4] = this.add.rope(Balloon[4].x, this.heightBalloon[4]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[5] = string[5] = this.add.rope(Balloon[5].x, this.heightBalloon[5]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[6] = string[6] = this.add.rope(Balloon[6].x-5, this.heightBalloon[6]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
       this.string[7] = string[7] = this.add.rope(Balloon[7].x, this.heightBalloon[7]+85, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);

        this.PurpleString = this.add.rope(895, 560, 'UIAssets',"NewAsset/Balloon_String_Purple.png",24,false);
        this.PurpleString.setColors(0x7753db);
        this.PurpleString.setDepth(5);

        this.addTween(this.PurpleString,3000,{y:{start:this.PurpleString.y + (1500 -this.mid.y), to:this.PurpleString.y}, delay:500},Phaser.Math.Easing.Quadratic.Out);

        for (x in string)
        {
            string[x].setScale(.75,.75);
            string[x].setDepth(0);
            //this.Balloons.
        }

        string[0].setColors(0xffa645);
        string[1].setColors(0xffa645);
        string[2].setColors(0xfc802d);
        string[3].setColors(0xfc802d);
        string[4].setColors(0xffa645);
        string[5].setColors(0xffa645);
        string[6].setColors(0xfc802d);
        string[7].setColors(0xfc802d);
        
        let cake = this.addImage(this.mid.x-17, this.mid.y + this.mid.y/2-5, "Title_Cake.png",this.Cake);
        const candleText = ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.candle");
        const letterWidth = 67;
        const candles = candleText.length;
        const midPoint = (candleText.length - 1)/2;
        const candleMidPoint = (candles - 1)/2;
        const yPath = new Phaser.Curves.Path(325, 327).lineTo(this.scale.width/2-20, 338).lineTo(665, 328);
        for(let i = 0; i < candles; i++)
        {
          this.addImage(this.scale.width/2 + ((i - candleMidPoint) * letterWidth) - 20,yPath.getPoint(i/(candles-1)).y+45,"Title_Candle.png",this.Cake).setOrigin(0.5, 0);
            flame[i] = this.addImage(this.scale.width/2 + ((i - candleMidPoint) * letterWidth) - 20,yPath.getPoint(i/(candles-1)).y,"Flame.png",this.Cake);
        }

        let candle = this.add.container();
        this.Cake.add(candle);
        for(let i = 0; i < candleText.length; i++)
        {
            ABCyaPhaser.Text.addText(this.scale.width/2 + ((i - midPoint) * letterWidth) - 20,yPath.getPoint(i/(candleText.length-1)).y, 90,0xff8622, FontKeys._snigletregular, candleText[i], candle ).setStroke("#ffcc39", 6)
        }

        const countingText = ABCyaPhaser.Localization.instance.getLocalizedString("title_screen.counting");
        const curvedCountingText = ABCyaPhaser.Text.addCurvedText(this.scale.width/2-20,568, ABCyaLib.Environment.instance.gameConfig.countingTitleFontSize, 0xffc7e2, FontKeys._snigletregular, countingText, 800, this.Cake, 90*Phaser.Math.DEG_TO_RAD, 0.9, false, true);
        curvedCountingText.y -= curvedCountingText.radius;
        curvedCountingText.letterTextFields.forEach(field => field.setShadow(5, 2, "#ed436c"));
        letters = curvedCountingText._letters;
        
        let banner = this.addImage(this.mid.x,-130, "Banner",this.cont, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
        var blln;

        candle.alpha = 0;
        this.counter = 0;
        this.Balloon = Balloon;
        this.flame = flame;
        this.letters = letters;

        /*
        //Skip to MakeAcake
        var text = this.add.text(30,700,"Click Here to skip to Make A Cake");
        text.setTint(0xef4f3b);
        text.on('pointerdown',()=>
        {
            this.scene.start("MakeACake");
        });
        text.setInteractive();
        

        var text = this.add.text(30,750,"Testing");
        text.setTint(0xef4f3b);
        text.on('pointerdown',()=>
        {
            this.scene.start("Test");
        });
        text.setInteractive();
        //*/

        gameData.bgMusic = this.playSound("bcc_jingle",.80,true);
       //console.log(gameData.bgMusic);
        gameData.bgMusic.stop();

        if(gameData.gameMuted != true)
        {
            gameData.bgMusic.play("bcc_jingle");
        }
        sound = this.playSound("birthday_candle_counting",1,false, true, Audio.LOCALIZATION_AUDIO_SPRITE);

        sound.once('complete',()=>{
            if(gameData.gameMuted != true)
            {
                this.playSound("balloons_rising",1); 
            }
        });

        var x;
        for (x in flame){
            flame[x].scale = 0;
            //flame[x].alpha = .8;
            flame[x].y -= 35;
        }

        for (x in letters){
            //letters[x].scale = 0;
            letters[x].alpha = 0;
            //letters[x].y = 900;
        }

        blln = this.addButton(892,1500, "NewAsset/Play_Balloon.png", null, ()=>{
            blln.disableInteractive();
            //console.log("BTN CLICKED! go to next scene");
            if(gameData.gameMuted != true)
            {
                this.playSound("balloons_rising",1); 
            }
            this.tweens.killAll();
            this.TransitionTweens(banner,bg,this.Cake,this.Balloons);
            this.addTween([blln,this.PurpleString], 700, {y:-800}, Phaser.Math.Easing.Quadratic.Out);

        });
        blln.setOrigin(.5,.5);
        blln.setDepth(5);
        blln.soundKey = "button_menu_click";

        if(gameData.gameMuted === true)
            {
                blln.PlaySound = false;
            }

        this.Balloons.setDepth(1);
        this.Cake.setDepth(2);


        this.addTween(banner, 1000, {y:60, yoyo:false}, Phaser.Math.Easing.Quadratic.Out);
        this.addTween(candle, 1000, {alpha: 1, yoyo:false, delay: 1000}, Phaser.Math.Easing.Quadratic.Out);

        x = 0;
        for (x in flame)
        {
            this.addTween(flame[x], 1000, {scale:1, alpha:.8, yoyo:false, delay: x*120}, Phaser.Math.Easing.Elastic.Out,);
        }

    
        for (x=0;x<4;x++)
        {
            this.addTween(Balloon[x], 3000, {y:this.heightBalloon[x], yoyo:false, delay: x*200}, Phaser.Math.Easing.Quadratic.Out);
            this.addTween(string[x], 3000, {y: {start: string[x].y + (Balloon[x].y - this.heightBalloon[x]), to: string[x].y}, yoyo:false, delay: x*200}, Phaser.Math.Easing.Quadratic.Out);
            counter=x+4;
            this.addTween(Balloon[counter], 3000, {y:this.heightBalloon[counter], yoyo:false, delay: x*200}, Phaser.Math.Easing.Quadratic.Out);
            this.addTween(string[counter], 3000, {y: {start: string[counter].y + (Balloon[counter].y - this.heightBalloon[counter]), to: string[counter].y}, yoyo:false, delay: x*200}, Phaser.Math.Easing.Quadratic.Out);
        }

        heightFire=[528,547,558,564,566,564,556,535];
        x=0
        for (x in letters)
        {
            this.addTween(letters[x], 3000, {alpha: 1, yoyo:false, delay: x*200}, Phaser.Math.Easing.Quadratic.Out);
        }

        this.addTween(blln,3000,{y:this.mid.y, delay:500},Phaser.Math.Easing.Quadratic.Out,()=>{
            this.IdleAnimation(blln);
            //this.addTween([blln,this.PurpleString], RandomTime, {y: + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
        });

        this.Balloons.add(string);
        for (x = 0; x < 8; x++)
        {
            this.Balloons.sendToBack(string[x]);
        }
        //console.log(gameData.bgMusic);
    }

    IdleAnimation(blln)
    {
        var RandomBalloonHeight;
        var x;
        var RandomTime;
        var RandomTimeFlame;
        for (x in this.Balloon)
        {
            RandomTime = Math.floor(Math.random() * 500)+1100;
            RandomBalloonHeight = Math.floor(Math.random() * 10)+5;
            this.addTween(this.Balloon[x], RandomTime, {y: this.heightBalloon[x] + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
            this.addTween(this.string[x], RandomTime, {y: this.string[x].y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
        }

        for (x in this.flame)
        {
            RandomTimeFlame = Math.floor(Math.random() * 500)+1100;
            this.addTween(this.flame[x], 400, {y: this.flame[x].y + 3, yoyo:true, loop: -1, delay: RandomTimeFlame}, Phaser.Math.Easing.Quadratic.In);
        }

        this.addTween(blln, RandomTime, {y: blln.y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);
        this.addTween(this.PurpleString, RandomTime, {y: this.PurpleString.y + RandomBalloonHeight, yoyo: true, loop: -1},Phaser.Math.Easing.Quadratic.InOut);

        this.LettersIdle();
    }

    LettersIdle()
    {
        var x;
        this.counter++;
        for (x in this.letters)
        {

            this.addTween(this.letters[x], 350, {scale: 1.1, yoyo:true, delay: x*200}, Phaser.Math.Easing.Quadratic.Out);

        }

        //this.addRepeatingEvent(15000,()=>{this.LettersIdle();});
    }

    cleanUp()
    {

       this.cont.destroy();

       this.scene.start("Candle");
    }

    TransitionTweens(Banner,Background,Cake,Balloon)
    {
        var x;
        var CakeLeaveTime = 1000;
        var CakeLeaveX = 1000;

        this.addTween(Banner, 700, {y:-170, yoyo:false}, Phaser.Math.Easing.Quadratic.Out);

        this.addTween(Cake, CakeLeaveTime, {x:Cake.x-CakeLeaveX, yoyo:false}, Phaser.Math.Easing.Quadratic.Out,()=>{ 
            if(gameData.gameMuted != true)
            {
                this.playSound("tween_down",1);
            }
            this.addTween(Background, 700, {y:Background.y + 606, yoyo:false}, Phaser.Math.Easing.Quadratic.Out,()=>{
                this.scene.start("Candle");
            });
        });
        

        this.addTween(Balloon, 700, {y:-800}, Phaser.Math.Easing.Quadratic.Out);
    }

    update()
    {
        //console.log(this.string[3].points);
        let points = [];
        let PurplePoints = [];
        var AngleOfLine = [2.5,3,2,3,3,2.5,5,2];
        var Direction = [-1,1,1,-1,1,-1,-1,1]
        var Delay = [.4,.34,.3,.27,.36,.38,.28,.29];
    
        points[0] = this.string[0].points;
        points[1] = this.string[1].points;
        points[2] = this.string[2].points;
        points[3] = this.string[3].points;
        points[4] = this.string[4].points;
        points[5] = this.string[5].points;
        points[6] = this.string[6].points;
        points[7] = this.string[7].points;

        this.count += .1;

        for (let loop = 0; loop < 8; loop++)
        {
            /*
            for (let i = 9; i < points[loop].length; i++)
            {
                points[loop][i].x = (Math.pow((i/AngleOfLine[loop]),2));
            }

            this.addDelay(1000);
            */

            for (let i = 9; i < points[loop].length; i++)
            {
                points[loop][i].x = Math.sin(i * Delay[loop] - this.count); //+ (Direction[loop]*points[loop][i].x);
            }
            

            this.string[loop].setDirty();
        }

        PurplePoints = this.PurpleString.points;

        for (let i = 9; i < PurplePoints.length; i++)
        {
            PurplePoints[i].x = Math.sin(i * .3 - this.count) * 2; 
        }

        this.PurpleString.setDirty();
        
    }
}
